



























































































































































































































import { Vue, Component, Prop, Ref, Watch, Emit } from 'vue-property-decorator'
import DraftOption from '@/modules/draft/components/LeagueOfLegends/DraftOption'
import DraftOptionGrid from '@/modules/draft/components/LeagueOfLegends/DraftOptionGrid'
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import * as signalR from '@microsoft/signalr'
import {
  DraftAPI,
  DraftEntity,
  DraftOptionEntity,
  DraftSessionEntity,
  DraftSessionState
} from '@/api/draft'
import ServerError from '@/utils/server_error'
import { now } from '@/utils/time'
import AppButton from '@/modules/shared/components/AppButton/AppButton.vue'
import Match from '@/modules/match/views/Match'
import DraftOptionSlot from '../slots'

@Component({
  components: { AppButton, DraftOption, DraftOptionGrid }
})
export default class DraftSession extends Vue {
  @Prop({ type: String, required: true })
  draftSessionId!: string

  @Prop({ type: String, required: true })
  teamNumber!: string

  @Prop({ type: Boolean, default: false })
  full!: boolean

  @Ref('header')
  headerDiv!: HTMLDivElement

  @Ref('footer')
  footerDiv!: HTMLDivElement

  hubConnection!: HubConnection
  choice: string = ''
  isAdmin = false

  gridHeight: number = 0

  // timer
  tick: number = 0
  timer: NodeJS.Timer | null = null

  // draft data
  draft: DraftEntity | null = null
  session: DraftSessionEntity | null = null
  options: DraftOptionEntity[] = []

  submitting: boolean = false

  @Watch('session')
  onSessionChanged() {
    this.$nextTick(() => {
      if (!this.headerDiv) {
        return
      }

      this.headerDiv.addEventListener('resize', this.updateGridHeight)
      this.updateGridHeight()
    })
  }

  @Watch('choice')
  async onChoiceChanged(newVal: string) {
    const teamNumber = parseInt(this.teamNumber)
    if (!this.currentResult || this.currentResult.teamNumber !== teamNumber)
      return

    try {
      await DraftAPI.updateChoice(this.draftSessionId, newVal, teamNumber)
    } catch (err) {
      // just ignore it
    }
  }

  @Emit('close')
  close() {
    return this
  }

  @Watch('draftSessionId')
  onDraftSessionIdChanged(newVal: string) {
    // dunno why need setTimeout but it works
    setTimeout(async () => {
      await this.doCleanUp()
      await this.doInit()
    })
  }

  get draftslot() {
    return this.stepOneTeamName === this.leftTeamName
      ? DraftOptionSlot.left
      : DraftOptionSlot.right
  }

  async doInit() {
    this.fetchDraftSession().then()
    this.fetchDraftOptions().then()

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_API_ENDPOINT + '/realtime')
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds() {
          return Math.random() * 5000
        }
      })
      .configureLogging(signalR.LogLevel.Debug)
      .build()

    await this.hubConnection.start()
    await this.hubConnection.send('SubscribeDraftSession', this.draftSessionId)

    await this.hubConnection.on('fullUpdate', this.fetchDraftSession)
    await this.hubConnection.on('choiceSubmitted', this.onChoiceSubmitted)

    this.timer = setInterval(() => {
      this.tick++
    }, 500)
  }

  async doCleanUp() {
    if (this.hubConnection) {
      await this.hubConnection.stop()
    }

    if (this.timer) {
      clearInterval(this.timer)
    }

    window.removeEventListener('resize', this.updateGridHeight)
  }

  async created() {
    await this.doInit()
  }

  async beforeDestroy() {
    await this.doCleanUp()
  }

  mounted() {
    window.addEventListener('resize', this.updateGridHeight)

    if (URLSearchParams) {
      const params = new URLSearchParams(window.location.search)
      this.isAdmin = params.get('admin') === '1'
    }
  }

  updateGridHeight() {
    if (!this.headerDiv) {
      this.gridHeight = 0
      return
    }

    // 64 is toolbar height
    this.gridHeight =
      window.innerHeight -
      this.headerDiv.clientHeight -
      (this.footerDiv ? this.footerDiv.clientHeight : 0) -
      45 +
      10
  }

  async fetchDraftOptions() {
    try {
      const res = await DraftAPI.getDraftOptions(this.draftSessionId)
      this.options = res.data.payload as DraftOptionEntity[]
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('Server error')
      }

      console.error(err)
    }
  }

  async fetchDraftSession() {
    try {
      const res = await DraftAPI.getDraftSession(this.draftSessionId)
      this.session = res.data.payload!.session as DraftSessionEntity
      this.draft = res.data.payload!.draft as DraftEntity
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('Server error')
      }

      console.error(err)
    }
  }

  async submitChoice() {
    this.submitting = true
    try {
      await DraftAPI.submitChoice(
        this.draftSessionId,
        this.choice,
        parseInt(this.teamNumber)
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('Server error')
      }

      console.error(err)
      await this.fetchDraftSession()
    } finally {
      this.submitting = false
    }
  }

  get timeleft() {
    // this line is important for updating timer.
    this.tick = this.tick
    return Math.max(
      0,
      Math.floor(this.session!.nextTimeoutTime - now().getTime() / 1000)
    )
  }

  get DraftSessionState() {
    return DraftSessionState
  }

  getResult(step: number) {
    console.log('step', this.session!.results, this.session!.currentStep)
    return this.session!.results.find(result => result.step === step)
  }

  getTeam(teamNumber: number) {
    return this.session!.teams.find(team => team.number === teamNumber)
  }

  get currentResult() {
    return this.getResult(this.session!.currentStep)
  }

  get myBans() {
    if (!this.session) return []

    return this.session!.results.filter(
      result =>
        result.action === 'Ban' &&
        result.teamNumber === parseInt(this.teamNumber)
    ).map(result => result.choice && result.choice.draftOptionId)
  }

  onChoiceSubmitted(args: {
    currentStep: number
    choice: string
    state: DraftSessionState
    nextTimeoutTime: number
  }) {
    if (!this.session) {
      return
    }

    this.choice = ''

    this.session.state = args.state
    this.session.currentStep = args.currentStep + 1
    this.session.nextTimeoutTime = args.nextTimeoutTime

    const result = this.session.results.find(
      result => result.step === args.currentStep
    )

    if (result) {
      result.choice = this.options.find(
        opt => opt.draftOptionId === args.choice
      ) as DraftOptionEntity
    }

    // make sure it updates everything
    this.session = { ...this.session }
  }

  get isMyTurn() {
    return (
      this.currentResult &&
      this.currentResult.teamNumber.toString() === this.teamNumber
    )
  }

  get disableIds() {
    var disabledIds = this.session!.results.filter(
      result => result.step < this.session!.currentStep
    )
      .filter(result => result.step <= 4 && this.session!.currentStep > 4)
      .map(result => result.choice)
      .filter(choice => choice)
      .map(choice => choice!.draftOptionId)
    console.log('disabled ids = ', disabledIds)

    if (this.myBans.length > 0) {
      return [...disabledIds, ...this.myBans]
    }

    return disabledIds
  }

  get stepOneTeamName() {
    if (!this.draft || !this.draft.steps || !this.draft.steps[0]) return ''
    const stepOneTeamNumber = this.draft.steps[0].teamNumber
    return this.getTeam(stepOneTeamNumber)!.name
  }

  get leftTeamName() {
    if (!this.session) {
      return '　'
    }

    const team = this.session.teams.find(team => team.number === 1)
    if (!team) {
      return '　'
    }

    return team.name
  }

  get rightTeamName() {
    if (!this.session) {
      return '　'
    }

    const team = this.session.teams.find(team => team.number === 2)
    if (!team) {
      return '　'
    }

    return team.name
  }
}
